import React, { Component } from 'react'
import { observer } from 'mobx-react'
import {
    Button,
    Modal,
    OverlayTrigger,
    Tooltip,
} from 'react-bootstrap'
import { BootstrapTable, TableHeaderColumn, defaultSortName, defaultSortOrder } from 'react-bootstrap-table'
import { injectStripe, CardElement } from 'react-stripe-elements';
import Loadable from 'react-loading-overlay'
import moment from 'moment'

@observer(['companies', 'globals'])
class SavedCards extends Component {
    constructor(props) {
        super(props)

        this.state = {
            stripeCustomerId: '',
            showNewCardModal: false,
            loadableState: true
        }
    }

    componentDidMount() {
        this.props.companies.getStripeCustomerId(this.props.companyId, (stripeCustomerId) => {
            if (stripeCustomerId != '') {
                this.setState({
                    stripeCustomerId: stripeCustomerId
                })
                this.loadSavedCards(stripeCustomerId)
            } else {
                console.log('No cards to load...')
                this.props.companies.resetSources()
                this.setState({
                    loadableState: false
                })
            }
        })
    }

    /*
    componentWillReceiveProps(props) {
        if (props.stripeCustomerId.length > 1 && props.stripeCustomerId != this.state.prevStripeCustomerId) {
            this.setState({
                prevStripeCustomerId: props.stripeCustomerId
            });
            this.loadSavedCards(props.stripeCustomerId); 
        }
    }
    */

    loadSavedCards(id, callback) {
        this.props.companies.getStripeSourcesByStripeCustomerId(id, () => {
            this.setState({
                loadableState: false
            })

            if (callback) {
                return callback()
            }
        })
    }

    openNewCardModal() {
        this.setState({
            showNewCardModal: true
        })
    }

    closeNewCardModal() {
        this.setState({
            showNewCardModal: false,
            loadableState: false
        })
    }

//SAVE RECORD HANDLERS
    handleSubmit(ev) {
        this.setState({
            loadableState: true,
            showNewCardModal: false
        })

        // We don't want to let default form submission happen here, which would refresh the page.
        ev.preventDefault();

        this.props.stripe.createToken().then(({ token }) => {
            console.log('Received Stripe token:', token);

            if (token && token.id) {
                //We need to remove the "." form the total dollar amount for Stripe.

                const params = {
                    companyId: this.props.companyId,
                    stripeCustomerId: this.state.stripeCustomerId,
                    stripeToken: token.id,
                    dateCreated: moment().unix()
                }

                this.props.companies.saveNewCreditCard(params, () => {
                    if (this.props.companies.saveCardResults.statusCode == 200) {
                        alert(this.props.companies.saveCardResults.data.message)
                        this.loadSavedCards(this.props.companies.saveCardResults.data.stripeCustomerId, () => {
                            this.setState({
                                stripeCustomerId: this.props.companies.saveCardResults.data.stripeCustomerId
                            })
                        })
                    }
                    else {
                        alert(this.props.companies.saveCardResults.data.message)
                        this.setState({
                            loadableState: false
                        })
                    }
                })
            } else {
                console
                alert('Please check your card information and try again.')
                this.setState({
                    loadableState: false
                })
            }            
        }).catch((err) => {
            console.log('Error: ', err)
        })
    }

    deleteSavedCard(stripeCardId) {
        if (confirm('Are you sure you want to delete this card?  This action cannot be undone!')) {
            console.log('Stripe Card Id: ', stripeCardId)
            this.setState({
                loadableState: true
            })

            const params = {
                stripeCustomerId: this.state.stripeCustomerId,
                stripeCardId: stripeCardId
            }
            console.log('Params: ', params)
            this.props.companies.deleteSavedCard(params, () => {
                if (this.props.companies.saveCardResults.statusCode == 200) {
                    alert(this.props.companies.saveCardResults.data.message)
                    this.loadSavedCards(this.props.companies.saveCardResults.data.stripeCustomerId, () => {
                        this.setState({
                            stripeCustomerId: this.props.companies.saveCardResults.data.stripeCustomerId
                        })
                    })
                }
                else {
                    alert(this.props.companies.saveCardResults.data.message)
                    this.setState({
                        loadableState: false
                    })
                }
            })
        }
    }

    formatCreditCard(cell, row) {
        return(
            <div>**** **** **** {cell}</div>
        )
    }

    formatActions(cell, row) {
        return (<div>
            <OverlayTrigger trigger={['hover', 'focus']} placement="top" overlay={ <Tooltip id={'deleteCard-' + cell}>Delete Card</Tooltip> }><Button bsSize="small" bsStyle="danger" id={cell} onClick={() => { this.deleteSavedCard(cell) }}><i className="fa fa-trash" aria-hidden="true"></i></Button></OverlayTrigger>
        </div>)
    }

    render() {
      const options = {
        defaultSortName: 'dateCreated',  // default sort column name
        defaultSortOrder: 'desc'  // default sort order
      }

        const savedCardsTable = (
            <div>
                <Button bsStyle="info" onClick={ this.openNewCardModal.bind(this) }><i className="fa fa-plus" aria-hidden="true"></i> New</Button>
                <BootstrapTable
                    data={this.props.companies.sources}
                    striped={true}
                    hover={true}
                    pagination={true}
                    search={true}
                    bordered={false}
                    options={ options }
                >
                    <TableHeaderColumn width="50" dataField="last4" isKey={true} dataSort={true} dataAlign="center" dataFormat={this.formatCreditCard.bind(this)} hiddenOnInsert={true} autoValue={true}>Card Number</TableHeaderColumn>
                    <TableHeaderColumn width="50" dataField="exp_month" dataSort={true} editable={false}>Expiration Month</TableHeaderColumn>
                    <TableHeaderColumn width="50" dataField="exp_year" dataSort={true} editable={false}>Expiration Year</TableHeaderColumn>
                    <TableHeaderColumn width="50" dataField="brand" dataSort={true} editable={false}>Card Type</TableHeaderColumn>
                    <TableHeaderColumn width="50" dataField="dateCreated" dataSort={true} dataAlign="center" autoValue={true}>Created</TableHeaderColumn>
                    <TableHeaderColumn width="50" dataField="id" hiddenOnInsert={true} autoValue={true} dataFormat={this.formatActions.bind(this)}>Actions</TableHeaderColumn>
                </BootstrapTable>
            </div>
        )

        return (
            <div>
                <Loadable active={ this.state.loadableState } spinner text='Processing your request...'>   
                    <div>
                        {savedCardsTable}
                    </div>
                    <Modal show={ this.state.showNewCardModal } onHide={ this.closeNewCardModal.bind(this) }>                        
                        <Modal.Header closeButton>
                            <Modal.Title>Add New Credit Card</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <form onSubmit={this.handleSubmit.bind(this)}>
                                <div className="form-row">
                                    <label htmlFor="card-element"></label>
                                        <CardElement style={{ base: { fontSize: '18px' } }} />
                                    <div id="card-errors" role="alert"></div>
                                </div>
                                <Button onClick={ this.handleSubmit.bind(this) } bsStyle="success">Save New Card</Button>
                                <Button bsStyle="danger" onClick={ this.closeNewCardModal.bind(this) }><i className="fa fa-times" aria-hidden="true"></i> Cancel</Button>
                            </form>
                        </Modal.Body>
                    </Modal>
                </Loadable>
            </div>
        )
    }
}

export default injectStripe(SavedCards);



// WEBPACK FOOTER //
// ./src/components/company/savedcards.js